import { render, staticRenderFns } from "./SamplePeriodSelector.vue?vue&type=template&id=a1c6d87e&"
import script from "./SamplePeriodSelector.vue?vue&type=script&lang=js&"
export * from "./SamplePeriodSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports